import { selectPropertyDateFormats } from '@hkm/components/Menu/PropertySelector/domain/selectors';
import { getStore } from '@hkm/store/configureStore';
import dayjs from 'dayjs';

export const getShortDateTime = (date: string): string => {
  const format: string = selectPropertyDateFormats(getStore())!.shortDateTime;

  return dayjs(date).format(format);
};



// WEBPACK FOOTER //
// ./src/shared/helpers/getShortDateTime.ts